<script>
import CommonMixin from './CommonMixin';

export default {
  name: 'LanguageRoute',
  mixins: [CommonMixin],
};
</script>

<template lang="pug">
PanelContainer.panel(id="languagepanel" usage="launcher" :modal="true" modalParentId="mainpanel")
  LanguageSelectBoxConnected.h-100
</template>

<style scoped>
.panel {
  width: 500px;
  flex-shrink: 0;
}
</style>
